'use client';

import type { ComponentPropsWithoutRef, ReactNode, Ref } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import type { Variant } from '../../shared.types';
import { Text } from '../../text/Text';

import styles from './FormFeedback.module.scss';

type FeedbackProps = ComponentPropsWithoutRef<'span'> &
  BaseComponentProps & {
    variant?: Variant;
    children?: ReactNode;
  };

export function FormFeedback({
  style,
  className,
  variant,
  children,
  testId = 'ui-form-feedback',
  ref,
  ...rest
}: FeedbackProps & { ref?: Ref<HTMLSpanElement> }) {
  return (
    <Text
      style={style}
      ref={ref}
      className={classnames(styles['main'], className)}
      variety="annotation"
      variant={variant}
      data-testid={testId}
      {...rest}
    >
      {children}
    </Text>
  );
}
